import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Normalize locale to a simple format (en or ar)
 * Handles formats like:
 * - "en" -> "en"
 * - "en-GB" -> "en"
 * - "en_US" -> "en"
 * - "ar-EG" -> "ar"
 * - "en_GB,en;q=0.9,en_US;q=0.8,ar;q=0.7" -> "en" (first locale)
 * 
 * @param locale - The locale string to normalize
 * @returns Normalized locale ("en" or "ar"), defaults to "en" if invalid
 */
export function normalizeLocale(locale: string | null | undefined): string {
  if (!locale) return "en";
  
  // Remove whitespace
  const trimmed = locale.trim();
  
  // Split by comma to get first language preference
  const firstLang = trimmed.split(',')[0].trim();
  
  // Remove quality value if present (e.g., "en;q=0.9" -> "en")
  const withoutQuality = firstLang.split(';')[0].trim();
  
  // Extract base language code (before dash or underscore)
  const baseLang = withoutQuality.split(/[-_]/)[0].toLowerCase();
  
  // Only allow supported locales
  return ["en", "ar"].includes(baseLang) ? baseLang : "en";
}
